import React from "react";
import { Skeleton } from "@envestnet/envreact-component-library";

const pageSkeleton = () => (
  <>
    <div style={{ display: "flex", marginTop: 16 }}>
      <Skeleton variant="circle" height={50} width={50} />
      <div>
        <Skeleton
          variant="text"
          height={30}
          width={100}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={60}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
      </div>
    </div>
    <div style={{ display: "flex", marginTop: 16 }}>
      <Skeleton variant="circle" height={50} width={50} />
      <div>
        <Skeleton
          variant="text"
          height={30}
          width={100}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={60}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
      </div>
    </div>
    <div style={{ display: "flex", marginTop: 16 }}>
      <Skeleton variant="circle" height={50} width={50} />
      <div>
        <Skeleton
          variant="text"
          height={30}
          width={100}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={20}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
        <Skeleton
          variant="text"
          height={60}
          width={280}
          animation="wave"
          style={{ marginLeft: 18 }}
        />
      </div>
    </div>
  </>
);

export default pageSkeleton;
